import { GetPackageAccommodationModel } from "@factory/model/query-model-package-accommodation";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { packageAccommodationFormDefault } from "./form.default";
import { PackageAccommodationFormSchema } from "./form.rule";

export const useFormDefaultPackageAccommodation = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetPackageAccommodationModel | undefined) => {
    return !cachedValue
      ? packageAccommodationFormDefault
     : ({
        package: cachedValue.package,
        night: cachedValue.night,
        hotel: cachedValue.hotel,
        roomType: cachedValue.room_type,
        numPeople: cachedValue.num_people,
        unit: cachedValue.unit,
        validFrom: cachedValue.valid_from,
        validUntil: cachedValue.valid_until,
        name: cachedValue.name,
        price: cachedValue.price,
        description: cachedValue.description,
      } as PackageAccommodationFormSchema);
  };

  return {
    getDefault,
  };
};
